/* MT Sports - personalizacao/preco + retoques v34 */
(function () {
  "use strict";

  if (window.__mtPersonalizacaoFixInitialized) return;
  window.__mtPersonalizacaoFixInitialized = true;

  function norm(v) {
    try {
      return (v || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    } catch (e) {
      return (v || "").toString().trim().toLowerCase();
    }
  }
  function style() {
    if (document.getElementById("mt-v34")) return;
    ["mt-v33", "mt-v32"].forEach(function (id) {
      var x = document.getElementById(id);
      if (x) x.remove();
    });
    var s = document.createElement("style");
    s.id = "mt-v34";
    s.textContent =
      '\
#aparecer.personalizacao,.personalizacao.mt-personalizacao-box,.line-item-property__field.mt-personalizacao-box{display:none!important;visibility:hidden!important;opacity:0!important;max-height:0!important;overflow:hidden!important;pointer-events:none!important;margin-top:0!important;}\
#aparecer.personalizacao.is-visible,.personalizacao.mt-personalizacao-box.is-visible,.line-item-property__field.mt-personalizacao-box.is-visible{display:block!important;visibility:visible!important;opacity:1!important;max-height:600px!important;overflow:visible!important;pointer-events:auto!important;margin-top:18px!important;}\
#aparecer.personalizacao.is-visible input,#aparecer.personalizacao.is-visible textarea,.personalizacao.mt-personalizacao-box.is-visible input,.personalizacao.mt-personalizacao-box.is-visible textarea,.line-item-property__field.mt-personalizacao-box.is-visible input,.line-item-property__field.mt-personalizacao-box.is-visible textarea{color:#000!important;-webkit-text-fill-color:#000!important;caret-color:#000!important;}\
#aparecer.personalizacao.is-visible input::placeholder,#aparecer.personalizacao.is-visible textarea::placeholder,.personalizacao.mt-personalizacao-box.is-visible input::placeholder,.personalizacao.mt-personalizacao-box.is-visible textarea::placeholder,.line-item-property__field.mt-personalizacao-box.is-visible input::placeholder,.line-item-property__field.mt-personalizacao-box.is-visible textarea::placeholder{color:#555!important;opacity:1!important;}\
.product-item__secondary-image{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}\
.product-item__image-wrapper--with-secondary .product-item__primary-image,.product-item__image-wrapper .product-item__primary-image{display:block!important;opacity:1!important;visibility:visible!important;transform:none!important;}\
.mt-buy-cart-icon{width:20px!important;height:20px!important;display:inline-block!important;vertical-align:-4px!important;margin-right:9px!important;flex:0 0 20px!important;}\
body.template-product .product-form__add-button:before,body.template-product .botaoflutuante .button--primary:before{display:none!important;content:none!important;}\
@media screen and (min-width:701px){\
.mt-home .mt-retro-feature{position:relative!important;overflow:hidden!important;background:#080a0e!important;isolation:isolate!important;}\
.mt-home .mt-retro-feature:before{display:block!important;content:\"\"!important;position:absolute!important;inset:-55px!important;z-index:0!important;background:url(\"https://cdn.shopify.com/s/files/1/0748/8415/3575/files/mt-ronaldinho-retro-desktop-final.jpg?v=1787466559\") center/cover no-repeat!important;filter:blur(42px) brightness(.27) saturate(.84)!important;transform:scale(1.18)!important;}\
.mt-home .mt-retro-feature:after{display:block!important;content:\"\"!important;position:absolute!important;inset:0!important;z-index:2!important;background:linear-gradient(90deg,rgba(8,10,14,.91) 0%,rgba(8,10,14,.68) 17%,rgba(8,10,14,.30) 31%,rgba(8,10,14,.08) 45%,transparent 58%),linear-gradient(0deg,rgba(8,10,14,.20),transparent 46%)!important;pointer-events:none!important;}\
.mt-home .mt-retro-feature__photo--desktop{display:block!important;position:absolute!important;z-index:1!important;inset:0 0 0 auto!important;width:72%!important;height:100%!important;max-width:none!important;max-height:none!important;object-fit:contain!important;object-position:center center!important;transform:none!important;filter:brightness(.78) contrast(1.03) saturate(.95)!important;background:transparent!important;-webkit-mask-image:linear-gradient(90deg,transparent 0%,rgba(0,0,0,.12) 5%,rgba(0,0,0,.48) 11%,rgba(0,0,0,.82) 17%,#000 23%,#000 77%,rgba(0,0,0,.82) 83%,rgba(0,0,0,.48) 89%,rgba(0,0,0,.12) 95%,transparent 100%)!important;mask-image:linear-gradient(90deg,transparent 0%,rgba(0,0,0,.12) 5%,rgba(0,0,0,.48) 11%,rgba(0,0,0,.82) 17%,#000 23%,#000 77%,rgba(0,0,0,.82) 83%,rgba(0,0,0,.48) 89%,rgba(0,0,0,.12) 95%,transparent 100%)!important;}\
.mt-home .mt-retro-feature__photo--mobile{display:none!important;}\
.mt-home .mt-retro-feature__shade{position:absolute!important;z-index:3!important;inset:0!important;background:linear-gradient(90deg,rgba(7,9,13,.98) 0%,rgba(7,9,13,.91) 18%,rgba(7,9,13,.68) 31%,rgba(7,9,13,.29) 47%,rgba(7,9,13,.07) 67%,rgba(7,9,13,0) 86%),linear-gradient(0deg,rgba(7,9,13,.32) 0%,rgba(7,9,13,0) 50%)!important;pointer-events:none!important;}\
.mt-home .mt-retro-feature__content{position:relative!important;z-index:4!important;}\
}';
    document.head.appendChild(s);
  }
  function scope(node) {
    return node && node.closest
      ? node.closest(".product-block-list__item--info") ||
          node.closest('[data-section-type="product"]') ||
          node.closest(".product-form") ||
          document
      : document;
  }
  function groups(root) {
    var a = [].slice.call(
      (root && root.querySelectorAll ? root : document).querySelectorAll(
        ".product-form__option",
      ),
    );
    if (!a.length && root !== document)
      a = [].slice.call(document.querySelectorAll(".product-form__option"));
    return a.filter(function (g) {
      var n = g.querySelector(".product-form__option-name");
      return (
        !!g.querySelector(".detect_variant") ||
        norm((n ? n.textContent : "") + " " + g.textContent).indexOf(
          "personalizar",
        ) > -1
      );
    });
  }
  function isPersonal(g) {
    var c = g && g.querySelector(".detect_variant:checked,input:checked");
    var s = g && g.querySelector("select");
    var v = c ? c.value : s ? s.value : "";
    var n = norm(v);
    return (
      n === "personalizar" ||
      n === "sim" ||
      n === "com personalizacao" ||
      n === "com personalizacao personalizada"
    );
  }
  function boxes(root) {
    var out = [];
    function add(sc) {
      if (!sc || !sc.querySelectorAll) return;
      [
        "#aparecer.personalizacao",
        "#aparecer",
        ".personalizacao",
        ".line-item-property__field",
      ].forEach(function (q) {
        [].slice.call(sc.querySelectorAll(q)).forEach(function (x) {
          if (out.indexOf(x) < 0) out.push(x);
        });
      });
    }
    add(root);
    if (!out.length && root !== document) add(document);
    return out;
  }
  function toggle(root, on) {
    boxes(root).forEach(function (b) {
      b.classList.add("mt-personalizacao-box");
      b.classList.toggle("is-visible", !!on);
      b.setAttribute("aria-hidden", on ? "false" : "true");
      b.style.setProperty("display", on ? "block" : "none", "important");
      b.style.setProperty("visibility", on ? "visible" : "hidden", "important");
      b.style.setProperty("opacity", on ? "1" : "0", "important");
      b.style.setProperty("max-height", on ? "600px" : "0", "important");
      b.style.setProperty("overflow", on ? "visible" : "hidden", "important");
      b.style.setProperty("pointer-events", on ? "auto" : "none", "important");
      b.querySelectorAll("input,select,textarea").forEach(function (el) {
        el.disabled = !on;
      });
      if (!on)
        b.querySelectorAll("input,textarea").forEach(function (el) {
          el.value = "";
        });
    });
  }
  function product(root) {
    var a = [];
    if (root && root.querySelectorAll)
      a = [].slice.call(root.querySelectorAll("script[data-product-json]"));
    if (!a.length)
      a = [].slice.call(document.querySelectorAll("script[data-product-json]"));
    for (var i = 0; i < a.length; i++) {
      try {
        var d = JSON.parse(a[i].textContent || "{}");
        if (d && d.product && d.product.variants) return d.product;
        if (d && d.variants) return d;
      } catch (e) {}
    }
    return null;
  }
  function chosen(root) {
    var vals = {};
    var sc = root && root.querySelectorAll ? root : document;
    var els = [].slice.call(
      sc.querySelectorAll(
        ".product-form__single-selector[data-option-position],input[data-option-position],select[data-option-position]",
      ),
    );
    if (!els.length && root !== document)
      els = [].slice.call(
        document.querySelectorAll(
          ".product-form__single-selector[data-option-position],input[data-option-position],select[data-option-position]",
        ),
      );
    els.forEach(function (el) {
      var p = parseInt(el.getAttribute("data-option-position"), 10);
      if (!p) return;
      if ((el.type === "radio" || el.type === "checkbox") && !el.checked)
        return;
      vals[p] = el.value;
    });
    return vals;
  }
  function variant(p, opts) {
    if (!p || !p.variants) return null;
    return (
      p.variants.find(function (v) {
        return Object.keys(opts).every(function (k) {
          var got = v["option" + k];
          if (got == null && v.options) got = v.options[parseInt(k, 10) - 1];
          return String(got) === String(opts[k]);
        });
      }) || null
    );
  }
  function money(c) {
    var raw = String(c == null ? "0" : c);
    var n = Number(c || 0);
    if (n < 1000 && raw.indexOf(".") > -1) n *= 100;
    try {
      return (n / 100)
        .toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        .replace(/\u00a0/g, " ");
    } catch (e) {
      return "R$ " + (n / 100).toFixed(2).replace(".", ",");
    }
  }
  function priceEls(root) {
    var qs = [
      "#evolution-price-list .price-promotional-wrap strong",
      "#evolution-price-list .price-promotional strong",
      "#evolution-price-list .price--highlight",
      ".product-price .price-promotional-wrap strong",
      ".product-price .price-promotional strong",
    ];
    var out = [];
    function add(sc) {
      qs.forEach(function (q) {
        [].slice.call(sc.querySelectorAll(q)).forEach(function (x) {
          if (out.indexOf(x) < 0) out.push(x);
        });
      });
    }
    if (root && root.querySelectorAll) add(root);
    if (!out.length) add(document);
    return out;
  }
  function syncVariant(origin) {
    var r = scope(origin),
      p = product(r),
      opts = chosen(r),
      v = variant(p, opts);
    if (!v) return null;
    var form =
      (origin &&
        origin.closest &&
        origin.closest('form[action*="/cart/add"],.product-form')) ||
      (r.querySelector &&
        r.querySelector('form[action*="/cart/add"],.product-form'));
    var ids =
      form && form.querySelectorAll
        ? form.querySelectorAll('input[name="id"],select[name="id"]')
        : document.querySelectorAll('input[name="id"],select[name="id"]');
    [].slice.call(ids || []).forEach(function (el) {
      if (String(el.value) !== String(v.id)) {
        el.value = String(v.id);
        el.dispatchEvent(new Event("change", { bubbles: false }));
      }
    });
    priceEls(r).forEach(function (el) {
      el.textContent = money(v.price);
    });
    var btn =
      (form &&
        form.querySelector &&
        form.querySelector(".product-form__add-button")) ||
      document.querySelector(".product-form__add-button");
    if (btn) {
      btn.disabled = v.available === false;
      btn.setAttribute("data-variant-id", v.id);
    }
    try {
      if (typeof window.parcelamento === "function")
        setTimeout(window.parcelamento, 20);
    } catch (e) {}
    return v;
  }
  function sync(origin) {
    var r = scope(origin),
      on = false;
    groups(r).forEach(function (g) {
      if (isPersonal(g)) on = true;
    });
    toggle(r, on);
    syncVariant(origin);
  }
  function cards() {
    document
      .querySelectorAll(".product-item__image-wrapper")
      .forEach(function (w) {
        w.classList.remove("product-item__image-wrapper--with-secondary");
        w.querySelectorAll(".product-item__secondary-image").forEach(
          function (i) {
            i.style.setProperty("display", "none", "important");
          },
        );
        var p = w.querySelector(".product-item__primary-image");
        if (p) {
          p.style.setProperty("display", "block", "important");
          p.style.setProperty("opacity", "1", "important");
          p.style.setProperty("visibility", "visible", "important");
          p.style.setProperty("transform", "none", "important");
        }
      });
  }
  function promoCards() {
    document.querySelectorAll(".mt-card").forEach(function (card) {
      var h = card.querySelector("h3");
      var promo = card.querySelector(".mt-card__promo");
      if (!promo) return;
      var title = norm(h ? h.textContent : "");
      var show =
        title.indexOf("camisa") > -1 &&
        title.indexOf("nba") === -1 &&
        title.indexOf("regata") === -1 &&
        title.indexOf("kit infantil") === -1 &&
        title.indexOf("conjunto") === -1;
      promo.style.setProperty("display", show ? "grid" : "none", "important");
    });
  }
  function icon() {
    document
      .querySelectorAll(
        "body.template-product .product-form__add-button,body.template-product .botaoflutuante .button--primary",
      )
      .forEach(function (b) {
        if (b.querySelector(".mt-buy-cart-icon")) return;
        var s = document.createElement("span");
        s.className = "mt-buy-cart-icon";
        s.setAttribute("aria-hidden", "true");
        s.innerHTML =
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1"></circle><circle cx="19" cy="20" r="1"></circle><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"></path></svg>';
        b.insertBefore(s, b.firstChild);
      });
  }
  function run(o) {
    style();
    cards();
    promoCards();
    icon();
    sync(o || document.body);
  }
  function later(t) {
    [0, 60, 160, 360, 750].forEach(function (ms) {
      setTimeout(function () {
        sync(t);
      }, ms);
    });
  }
  document.addEventListener("change", function (e) {
    if (
      e.target &&
      e.target.matches &&
      e.target.matches(
        ".product-form__single-selector,.block-swatch__radio,.variant-swatch__radio,[data-option-position]",
      )
    ) {
      run(e.target);
      later(e.target);
    }
  });
  document.addEventListener("click", function (e) {
    var t =
      e.target && e.target.closest
        ? e.target.closest(
            ".product-form__option label,.block-swatch__item,.variant-swatch__item",
          )
        : null;
    if (t) later(t);
  });
  function init() {
    run(document.body);
    setTimeout(function () {
      run(document.body);
    }, 250);
    setTimeout(function () {
      run(document.body);
    }, 900);
    new MutationObserver(function () {
      cards();
      promoCards();
      icon();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
